import { styled } from "@mui/material";
import PieChart from "../../Chart/PieChart";
import { BoxUpper } from "../BoxUpper";
import { RawBox } from "./styled";
import { options } from "assets/js/widgetItems";
import { useMediaQuery } from "@mui/material";

const BoxBodyContainer = styled("div")(({ theme }) => ({
  height: "350px",
  display: "grid",
  gridTemplateColumns: "100%",

  // [theme.breakpoints.down("sm")]: {
  //   display: "block", // Apply flex when screen size matches 'sx'
  // },
}));

const PieChartComponent = ({
  title,
  data,
  onSelect,
}: {
  title?: string;
  data: PieChartDataType;
  onSelect?: (filterType: string) => void;
}) => {
  const isSxSize = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  return (
    <RawBox>
      <BoxUpper title={title} />
      {/*<BoxUpper title={title} options={options} onChange={onSelect} />*/}
      <BoxBodyContainer sx={{ display: "block" }}>
        <PieChart data={data} />
      </BoxBodyContainer>
    </RawBox>
  );
};

export default PieChartComponent;
